module.exports = __webpack_public_path__ + "img/check.2e56b874.svg";